import React from 'react';

const MainCircleCard = ({ circleCards }) => {
  
  return (
    <div className={circleCards.wrapClass}>
      <div className={circleCards.titleClass}>
        {circleCards.title}
      </div>
      <div>
        {circleCards.content}
      </div>
    </div>
  );
}

export default MainCircleCard;
